import Vuex from 'vuex';
import brandPortal from './modules/brandPortal';
import campaign from './modules/campaign';
import campaignList from './modules/campaignList';
import profile from './modules/profile';
import survey from './modules/survey';
import fulfillment from './modules/fulfillment';
import country from './modules/country';
import cart from './modules/cart';

// plugins
import cartLocalStoragePlugin from './plugins/cartLocalStoragePlugin';

const createStore = () => new Vuex.Store({
    modules: {
        brandPortal,
        campaign,
        campaignList,
        country,
        profile,
        survey,
        fulfillment,
        cart
    },
    state: {
        // Sourced from the value Sails injects into the page at runtime
        // (window.SAILS_LOCALS.domain, set by api/hooks/decorate.js on every GET).
        // Deliberately NOT read from process.env.STUDIOS_HOME_URL: webpack bakes that
        // at build time, and in the Docker/CI image build it is unset, so it resolved
        // to a literal `undefined` baked into the bundle that broke every homeUrl link.
        homeUrl: typeof window !== 'undefined' ? window.SAILS_LOCALS?.domain : undefined
    },
    plugins: [cartLocalStoragePlugin]
});

export default createStore;
